/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseDataWidgetConfigurationModel extends models.WidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("BaseDataWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return BaseDataWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<BaseDataWidgetConfigurationModel>): BaseDataWidgetConfigurationModel {
        let obj = Object.assign(new BaseDataWidgetConfigurationModel(), model);
        BaseDataWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseDataWidgetConfigurationModel>): BaseDataWidgetConfigurationModel {
        if (!model) return null;
        return BaseDataWidgetConfigurationModel.newInstance(<BaseDataWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseDataWidgetConfigurationModel) {
        if (!obj) return;

        models.BaseDataWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseDataWidgetConfigurationModel): boolean {
        if (models.WidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseDataWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.context) {
            models.DataContext.fixupPrototype(this.context);
        }
        if (this.navigationDescriptors) {
            for (let val of this.navigationDescriptors) {
                models.WidgetNavigationDescriptor.fixupPrototype(val);
            }
        }
    }

    contextSelector: string;

    context: models.DataContext;

    navigationDescriptors: Array<models.WidgetNavigationDescriptor>;

    /**
     * When true in-widget filters will not be displayed.
     */
    hideWidgetFiltering: boolean;

}
